import { render, staticRenderFns } from "./DeliveryPointOpeningHoursForm.vue?vue&type=template&id=051c32e0"
import script from "./DeliveryPointOpeningHoursForm.vue?vue&type=script&lang=js"
export * from "./DeliveryPointOpeningHoursForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports